const plugin = () => {
    // store.subscribe((mutation, state) => {
    //     console.log('sync - mutation', mutation.type, state)
    // //   switch (mutation.type) {
    // //     case '...':
    // //       // dispatch request
    // //       break;
    // //     case '...':
    // //       // dispatch request
    // //       break;  
    // //     default:
    // //     // Ignore default case
    // //   }
    // });
  };
  
  export default plugin;